<template>
    <div class="spf" v-if="selectedTool && (selectedTool.id === 'singlePointofFailure')">
        <h5 style="margin-bottom: 10px; text-align: left;"><u>{{ $t('SelectTwoBuildings') }}</u></h5>
        <tools-buttons @set-selection="setSelection"/>
        <div class="clear-all-container">
            <h5
                v-if="selectionType"
                @click="deleteAll"
                style="margin-top: 10px; cursor: pointer;"
            >
                <u>{{ $t('ClearAll') }}</u>
            </h5>
        </div>
        <div
            v-if="selectionType"
            class="floating-object-selected"
            v-for="building in getBuildings"
            :key="building.uuid"
        >
            <div class="building-info">
                <img :src="require(`@/assets/spf/building.png`)" style="width: 15px; height: 15px;">
                <span style="text-align: left; padding-left: 5px; color: black;">
                    {{ objectIdentification(building) }}
                </span>
            </div>
            <v-icon
                small
                class="delete-icon"
                @click="deleteBuilding(building)"
            >
                mdi-delete
            </v-icon>
        </div>
        <div class="spf-action-btns-container">
            <p @click="cancelSpf">{{ $tc(`Cancel`) }}</p>
            <p @click="executeSpf"><u>{{ $tc(`Execute`) }}</u></p>
        </div>
    </div>
    <div v-else-if="selectedTool" class="failure-Analysis-action-btns-container">
        <p @click="cancelFa">{{ $tc(`Cancel`) }}</p>
    </div>
    
</template>
  
<script>
    import { mapActions } from "vuex";
    import ToolsButtons from "../ToolsButtons.vue";
    import { bus } from "@/main";

    export default {
        name: "SinglePointOfFailure",
        components: {
            ToolsButtons
        },
        data() {
            return {
                selectionType: null,
            };
        },
        computed: {
            /**
             * Returns the selected tool
             */
            selectedTool() {
                return this.$store.getters.getSelectedTool;
            },
            getBuildings(){
                return this.$store.getters.getSpfBuildings;
            }
        },   
        methods: {
            ...mapActions([
                "deleteBuildingSPF",
                "deleteAllSPF"
            ]),
            setSelection(type){
                this.selectionType = type;
                bus.$emit("set-spf-selection-type", type);
            },
            deleteAll(){
                bus.$emit("clear-all-spf");
            },
            objectIdentification(object) {
                let label = "";
                if (object.label) {
                    label += object.label;
                } else {
                    label += object.id;
                }
                return `${this.$tc(`Building`, 1)} ${label}`
            },
            deleteBuilding(building){
                this.deleteBuildingSPF(building.id);
                bus.$emit("remove-selected-building");
            },
            cancelSpf(){
                this.deleteAllSPF();
                bus.$emit("cancel-spf");
            },
            cancelFa(){
                bus.$emit("cancel-fa");
            },
            executeSpf(){
                if(this.getBuildings.length < 2){
                    this.$toasted.global.toast_error("Please select at least two buildings");
                    return
                }
                bus.$emit("execute-spf");
            },
        }
    }
</script>
  
<style scoped>
.spf{
  width: 100%;
  height: 90%;
  overflow: auto;
  padding-bottom: 4px;
  padding: 0px 15px;
  margin-top: 25px;
}
.clear-all-container{
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.building-info {
  display: flex;
  align-items: center;
}
.delete-icon {
  margin-left: auto;
  cursor: pointer;
}
.spf-action-btns-container{
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.spf-action-btns-container > p {
  cursor: pointer;
}
.failure-Analysis-action-btns-container > p {
  cursor: pointer;
  width: 100%;
  height: 90%;
  overflow: auto;
  padding-bottom: 4px;
  padding: 0px 15px;
  margin-top: 25px;
}
</style>
  


// WEBPACK FOOTER //
// src/components/Network/RightSidebar/spf/SinglePointOfFailure.vue